export default __webpack_public_path__ + "static/media/Banner_Sitio web 1_.9d9820a3.png";